module.exports = __webpack_public_path__ + "img/step10.3f2b51e6.png";